import { profileAPI } from "@/lib/api/api";
import { PROFILE_QUERY_KEY } from "@/lib/queryKeys";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

type ProfileSection =
  | "awardSection"
  | "courseAndCertificationSection"
  | "educationDetailSection"
  | "employmentDetailSection"
  | "jobPreferenceSection"
  | "languageSection"
  | "manageProfileSection"
  | "personalDetailSection"
  | "projectDetailSection"
  | "resumeSection"
  | "skillSection"
  | "socialPresenceSection"
  | "workSampleSection";

// type ProfileData = {
//   awardSection?: any;
//   courseAndCertificationSection?: any;
//   educationDetailSection?: any;
//   employmentDetailSection?: any;
//   jobPreferenceSection?: any;
//   languageSection?: any;
//   manageProfileSection?: any;
//   personalDetailSection?: any;
//   projectDetailSection?: any;
//   resumeSection?: any;
//   skillSection?: any;
//   socialPresenceSection?: any;
//   workSampleSection?: any;
// };

export const useProfileData = () => {
  return useQuery({
    queryKey: [PROFILE_QUERY_KEY],
    queryFn: () =>
      profileAPI<any>(
        "personal_details,awards,courses_and_certifications,educations,job_preferences,additional_profiles,projects,resumes,employments,languages,skills_and_it_skills,social_presence,work_sample",
      ),
  });
};

type ProfileSectionResult<T> = Omit<UseQueryResult<T, Error>, "data"> & {
  data: T | undefined;
};

export const useProfileSectionData = <T>(
  section: ProfileSection,
): ProfileSectionResult<T> => {
  const query = useProfileData();

  return {
    ...query,
    data: query.data ? ({ [section]: query.data?.[section] } as T) : undefined,
  };
};
